// api/invite.ts - InviteController endpoints (прийняття запрошень tenant'ом)

import { AxiosResponse } from 'axios';
import $api from './instance';
import {
  InviteInfo,
  AcceptInviteResponse
} from '@/types/entities';
import {
  AcceptInviteData
} from '@/types/api-types';

// === INVITE API для TENANT ===

/**
 * Отримати інформацію про запрошення перед прийняттям
 * GET /invite/:token/info
 */
export async function getInviteInfoRequest(
  token: string,
): Promise<AxiosResponse<InviteInfo>> {
  return $api.get<InviteInfo>(`/invite/${token}/info`);
}

/**
 * Прийняти запрошення (створює активний lease)
 * POST /invite/accept/:token
 */
export async function acceptInviteRequest(
  token: string,
  tenantData?: AcceptInviteData,
): Promise<AxiosResponse<AcceptInviteResponse>> {
  return $api.post<AcceptInviteResponse>(
    `/invite/accept/${token}`,
    tenantData,
  );
}

/**
 * Перевірити, чи зареєстрований користувач за токеном запрошення.
 * GET /invite/check/:token
 */
export async function checkUserRegistrationStatus(
  token: string,
): Promise<AxiosResponse<{ isUserRegistered: boolean }>> {
  return $api.get<{ isUserRegistered: boolean }>(`/invite/check/${token}`);
}

// === INVITE API для OWNER (відкликання запрошень) ===

/**
 * Відкликати невикористане запрошення, пов'язане з конкретним юнітом.
 * DELETE /api/invite/unit/:unitId
 */
export async function revokeInviteRequest(
  unitId: number,
): Promise<AxiosResponse<any>> {
  return $api.delete(`/invite/unit/${unitId}`);
}

// === ДОПОМІЖНІ ФУНКЦІЇ ===

/**
 * Перевірити статус запрошення без повних деталей
 * GET /invite/:token/status (якщо такий endpoint існує)
 */
export async function checkInviteStatusRequest(
  token: string,
): Promise<AxiosResponse<{
  status: 'pending' | 'accepted' | 'expired' | 'cancelled';
  valid: boolean;
  expiresAt: string;
}>> {
  return $api.get(`/invite/${token}/status`);
}

// === LEGACY ПІДТРИМКА ===

/**
 * @deprecated Використовуйте acceptInviteRequest замість цього
 */
export async function linkPropertyRequest(token: string) {
  return $api.post(`/invite/use/${token}`);
}